export const LOGIN_ERROR_MESSAGES_CONSTANT = {
  CODES: {
    V_31: 'V-31',
    S_70: 'S-70',
    S_35: 'S-35',
    S_97: 'S-97',
    V_190: 'V-190',
  },
  MESSAGES: {
    CHANGE_PASSWORD_TEXT: 'Cambiar contraseña',
    TRY_AGAIN_TEXT: 'Volver a intentar',
    RETURN_TEXT: 'Volver',
    REGISTER_NOW_TEXT: 'Regístrate ahora',
    UPS_CONST_TEXT: '¡Ups!',
  },
};
